import { AppConfigStructure } from './config';

const devConfig: AppConfigStructure = {
  name: 'development',

  intercom: {
    isOn: false,
  },

  sentry: {
    isOn: false,
    DSN: 'https://0cd6aef08375436998965905c89961c9@sentry.io/1280773',
  },

  fullStory: {
    isOn: false,
  },

  eventTracker: {
    isOn: true,
  },

  isStaffModeAllowed: true,

  splitFeatureFlagSystem: {
    isOn: true,
    key: '723rg4o5ndu20a0dcq0jh37r5bnks2lr1ahb',
  },

  features: {},
};

export default devConfig;
